// import React, { useState } from "react";
// import "../styles/FdMisReport.css";

// export default function FdMisReport() {
//   const [filters, setFilters] = useState({
//     accountType: "",
//     fromDate: "",
//     toDate: "",
//     status: "",
//   });

//   const handleChange = (e) => {
//     setFilters({ ...filters, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log(filters);
//   };

//   const reportData = [
//     {
//       sn: 1,
//       account: "MUZMIS00001",
//       status: "Approved",
//       name: "Rahul",
//       guardian: "1Demo guardian",
//       mobile: "1234567891",
//       aadhar: "123456789019",
//       approvalDate: "2000-01-01",
//       approvedBy: "Demo Manager",
//     },
//     {
//       sn: 2,
//       account: "H02FD0100001",
//       status: "Approved",
//       name: "PANKAJ KUMAR",
//       guardian: "RAM KUMAR",
//       mobile: "9897651265",
//       aadhar: "987869431654",
//       approvalDate: "2025-03-21",
//       approvedBy: "AKASH",
//     },
//     {
//       sn: 3,
//       account: "H02FD0100002",
//       status: "Approved",
//       name: "AKASH",
//       guardian: "SHUBHAM",
//       mobile: "6325147896",
//       aadhar: "584713269984",
//       approvalDate: "2025-05-29",
//       approvedBy: "AKASH",
//     },
//   ];

//   return (
//     <div className="FdMisReport">
//       {/* FILTER SECTION */}
//       <section className="filter-section">
//         <h2>Account Report Filter</h2>
//         <p>Use filter to see more precised report</p>
//         <form onSubmit={handleSubmit} className="filter-form">
//           <div className="form-group">
//             <label>Choose Account Type</label>
//             <select name="accountType" value={filters.accountType} onChange={handleChange}>
//               <option value="">Select account type</option>
//               <option value="FD">Fixed Deposit</option>
//               <option value="MIS">Monthly Income Scheme</option>
//             </select>
//           </div>

//           <div className="form-group">
//             <label>From Date</label>
//             <input type="date" name="fromDate" value={filters.fromDate} onChange={handleChange} />
//           </div>

//           <div className="form-group">
//             <label>To Date</label>
//             <input type="date" name="toDate" value={filters.toDate} onChange={handleChange} />
//           </div>

//           <div className="form-group">
//             <label>Choose Account Status</label>
//             <select name="status" value={filters.status} onChange={handleChange}>
//               <option value="">Select status</option>
//               <option value="Approved">Approved</option>
//               <option value="Pending">Pending</option>
//             </select>
//           </div>

//           <button type="submit" className="filter-button">Submit</button>
//         </form>
//       </section>

//       {/* REPORT SECTION */}
//       <section className="report-section">
//         <h2>Fixed Deposit Report</h2>
//         <div className="report-controls">
//           <label>
//             Search:
//             <input type="text" placeholder="Search..." />
//           </label>
//           <label>
//             Show
//             <select>
//               <option>10</option>
//               <option>25</option>
//               <option>50</option>
//             </select>
//             entries
//           </label>
//         </div>

//         <div className="table-responsive">
//           <table className="fdmis-report-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Account</th>
//                 <th>Interest Details</th>
//                 <th>Status</th>
//                 <th>Name</th>
//                 <th>Guardian</th>
//                 <th>Mobile</th>
//                 <th>Aadhar</th>
//                 <th>Approval Date</th>
//                 <th>Approved By</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reportData.map((row, i) => (
//                 <tr key={i}>
//                   <td>{row.sn}</td>
//                   <td>{row.account}</td>
//                   <td><button className="view-btn">View Details</button></td>
//                   <td>{row.status}</td>
//                   <td>{row.name}</td>
//                   <td>{row.guardian}</td>
//                   <td>{row.mobile}</td>
//                   <td>{row.aadhar}</td>
//                   <td>{row.approvalDate}</td>
//                   <td>{row.approvedBy}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </section>
//     </div>
//   );
// }

// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import "../styles/RdDdReport.css";
// import "../styles/FdMisReport.css"
// import toast, { Toaster } from "react-hot-toast";

// const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
// const rowsPerPage = 10;

// const FdMisReport = () => {
//   const [activeMainTab, setActiveMainTab] = useState("FD");
//   const [activeSecondary, setActiveSecondary] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accounts, setAccounts] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [modalOpen, setModalOpen] = useState(false);
//   const [adminRemark, setAdminRemark] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [selectedreport,setselectedreport]=useState("");
//   const [userid,setuserid]=useState("");

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   // ✅ Fetch API Data
//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       const superAdminId = localStorage.getItem("adminuserId") || 14;

//       const res = await axios.get("https://payyug.in/api/fdmis/all?superAdminId", {
//         params: {
//           superAdminId,
//           page: currentPage,
//           limit: rowsPerPage,
//           accountType: activeMainTab,
//           status: activeSecondary !== "All" ? activeSecondary : undefined,
//           search: searchQuery || undefined,
//         },
//       });

//       if (res.data.success) {
//         setAccounts(res.data.data || []);
//         setTotalPages(res.data.totalPages || 1);

//       } else {
//         setAccounts([]);
//       }
//     } catch (err) {
//       console.error("Error fetching deposit accounts:", err);
//       setAccounts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch whenever filters or page changes
//   useEffect(() => {
//     fetchAccounts();
//   }, [activeMainTab, activeSecondary, searchQuery, currentPage]);

//   // Reset page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [activeMainTab, activeSecondary]);

//   // Render Table
//   const renderTable = useMemo(() => {
//     if (loading) {
//       return (
//         <tr>
//           <td colSpan="10" style={{ textAlign: "center" }}>
//             Loading...
//           </td>
//         </tr>
//       );
//     }

//     if (!accounts.length) {
//       return (
//         <tr>
//           <td colSpan="10" style={{ textAlign: "center" }}>
//             No Data Found
//           </td>
//         </tr>
//       );
//     }

//     return accounts.map((acc, index) => (
//       <tr key={acc.id}>
//         <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//         <td>{acc.accountNo}</td>
//         <td>{acc?.customerName || "NA"}</td>
//         <td>{acc.accountType || "NA"}</td>
//         <td>{acc.roi || "NA"}%</td>
//         <td>₹{acc.minDeposit || 0}</td>
//         <td>₹{acc.loanAmount || 0}</td>
//         <td>{acc.lockinPeriod || 0}</td>
//         <td>{acc.referId || "NA"}</td>
//         <td>{acc.nomineeId || "NA"}</td>
//         <td>
//           <button
//             className="DDFDReportview-btn"
//             onClick={() => alert(`Viewing ${acc.accountNo}`)}
//           >
//             View
//           </button>
//         </td>
//       </tr>
//     ));
//   }, [accounts, loading, currentPage]);

//   const openRemarkModal = (report,status) => {
//     setuserid(report.id);
//     setselectedreport(report);
//     console.log(selectedreport.id);
//     setSelectedStatus(status);
//     setAdminRemark("");
//     setModalOpen(true);
//   };

//  const submitStatusUpdate = async () => {
//       if (!adminRemark.trim()) {
//         return toast.error("Admin remark is required!");
//       }
//        const superAdminId = localStorage.getItem("superAdminId") || 14;
//        try {
//         await axios.post(
//           `https://payyug.in/api/fdmis/${selectedStatus}`,
//           {
//             accountId:userid,
//              ...(selectedStatus==="approve"
//                ?{approvedBy:superAdminId}
//                :{rejectedBy:superAdminId}),
//             remarks:adminRemark,
//           }
//         );

//         toast.success(`acc ${selectedStatus} successfully`);

//         } catch (error) {
//         toast.error(error?.response?.data?.error || "Failed to update account");
//         setModalOpen(false);
//       }
//   };

//   console.log(accounts);
//   return (
//     <div className="DDFDReport-container">
//       <h2 style={{ textAlign: "center", marginBottom: 10 }}>
//         {activeMainTab} Account Report
//       </h2>

//       {/* Tabs */}
//       <div className="DDFDReport-main-tabs">
//         {["FD", "MIS"].map((tab) => (
//           <button
//             key={tab}
//             className={`DDFDReport-main-btn ${
//               activeMainTab === tab ? "active" : ""
//             }`}
//             onClick={() => setActiveMainTab(tab)}
//           >
//             {tab} Report
//           </button>
//         ))}
//       </div>

//       {/* Secondary Tabs */}
//       <div className="DDFDReport-secondary-tabs">
//         {secondaryTabs.map((tab) => (
//           <button
//             key={tab}
//             className={`DDFDReport-secondary-btn ${
//               activeSecondary === tab ? "active" : ""
//             }`}
//             onClick={() => setActiveSecondary(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Search */}
//       <div className="DDFDReportsearch-box">
//         <input
//           type="text"
//           placeholder="Search by Account No / Customer..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>
// {/* Table */}
//       <div className="DDFDReporttable-container">
//         <table className="DDFDReport-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               <th>Account No</th>
//               <th>Customer Name</th>
//               <th>Account Type</th>
//               <th>Status</th>               {/* NEW */}
//               <th>Roi</th>
//               <th>Deposit Amount</th>       {/* NEW */}
//               <th>Tenure</th>               {/* NEW */}

//               {/* <th>Nominee ID</th> */}
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="14" style={{ textAlign: "center" }}>Loading...</td>
//               </tr>
//             ) : accounts.length === 0 ? (
//               <tr>
//                 <td colSpan="14" style={{ textAlign: "center" }}>No Data Found</td>
//               </tr>
//             ) : (
//               accounts.map((acc, index) => (
//                 <tr key={acc.id}>
//                   <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                   <td>{acc.accountNumber}</td>
//                   <td>{acc.customerName || "NA"}</td>
//                   <td>{acc.accountType || "NA"}</td>

//                   {/* NEW STATUS FIELD */}
//                   <td>{acc.status || "NA"}</td>

//                   <td>{acc.roi || "NA"}%</td>

//                   {/* NEW DEPOSIT AMOUNT */}
//                   <td>₹{acc.depositAmount || acc.minDeposit || 0}</td>

//                   {/* NEW TENURE */}
//                   <td>{acc.tenureMonths || "NA"}</td>

//                   {/* <td>{acc.nomineeName || "--"}</td> */}

//                   <td>
//                       <div className="action-buttons-fdmis">
//                         <button
//                           className="approve-btn"
//                           // onClick={() => openRemarkModal(acc,"approve")}
//                         >
//                           Approve
//                         </button>

//                         <button
//                           className="reject-btn"
//                           // onClick={() => openRemarkModal(acc,"reject")}
//                         >
//                           Reject
//                         </button>
//                       </div>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="DDFDReportpagination">
//         <button
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((p) => p - 1)}
//         >
//           Previous
//         </button>
//         <span>
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((p) => p + 1)}
//         >
//           Next
//         </button>
//       </div>

//       {/* Modal */}
//       {modalOpen && (
//         <div className="remark-modal-overlay">
//           <div className="remark-modal">
//             <h3>
//               {selectedStatus === "approve" ? "Approve report": "Reject report"}
//             </h3>

//             <textarea
//               placeholder="Enter admin remark"
//               value={adminRemark}
//               onChange={(e) => setAdminRemark(e.target.value)}
//             ></textarea>

//             <div className="modal-buttons">
//               <button className="modal-submit" onClick={submitStatusUpdate}>
//                 Submit
//               </button>
//               <button
//                 className="modal-cancel"
//                 onClick={() => setModalOpen(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default FdMisReport;

import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "../styles/FdMisReport.css";
import { toast, ToastContainer } from "react-toastify";
import { ArrowUpRight, CheckCircle, Trash, XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
const secondaryTabs = [
  "All",
  "Active",
  "Pending",
  "Closed",
  "Pre-Closed",
  "Rejected",
];

const FdMisReport = () => {
  const [activeMainTab, setActiveMainTab] = useState("FD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [frequency, setFrequency] = useState("All");

  const [modalOpen, setModalOpen] = useState(false);
  const [adminRemark, setAdminRemark] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedreport, setselectedreport] = useState("");
  const [userid, setuserid] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate=useNavigate();

  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    accId: null,
  });

  const fetchAccounts = async () => {
    try {
      setLoading(true);

      const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;
      // https://payyug.in/api/fdmis/all-new?superAdminId=14&branchId=65&createdBy=56&page=1&limit=10&accountType=MIS
      const res = await axios.get("https://payyug.in/api/fdmis/all-new", {
        params: {
          superAdminId,
          accountType: activeMainTab,
        },
      });

      //   const accounts = Array.isArray(res?.data?.data)
      //   ? res.data.data
      //   : [];

      // // Remove pending accounts safely
      // const filtered = accounts.filter(
      //   (acc) =>
      //     acc?.status &&
      //     acc.status.trim().toLowerCase() !== "pending"
      // );

      if (res.data.success) {
        setAccounts(res.data.data || []);
      }
    } catch (err) {
      console.error(err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, [activeMainTab]);

  const filteredAccounts = useMemo(() => {
    let data = [...accounts];

    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase();

      data = data.filter(
        (acc) =>
          acc.accountNo?.toLowerCase().includes(query) ||
          acc.customerName?.toLowerCase().includes(query),
      );
    }

    // 🔹 STATUS FILTER
    if (activeSecondary !== "All") {
      data = data.filter(
        (acc) => acc.status?.toLowerCase() === activeSecondary.toLowerCase(),
      );
    }

    // 🔹 FREQUENCY FILTER
    if (frequency !== "All") {
      data = data.filter(
        (acc) =>
          acc.installmentFrequency?.toLowerCase() === frequency.toLowerCase(),
      );
    }

    return data;
  }, [accounts, activeSecondary, frequency, searchQuery]);

  const submitStatusUpdate = async () => {
    if (!adminRemark.trim()) {
      return toast.error("Admin remark is required!");
    }
    const superAdminId = localStorage.getItem("superAdminId") || 14;
    try {
      await axios.post(`https://payyug.in/api/fdmis/${selectedStatus}`, {
        accountId: userid,
        ...(selectedStatus === "approve"
          ? { approvedBy: superAdminId }
          : { rejectedBy: superAdminId }),
        remarks: adminRemark,
      });

      toast.success(`acc ${selectedStatus} successfully`);
      setModalOpen(false);
      fetchAccounts();
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to update account");
      setModalOpen(false);
    }
  };

  const openRemarkModal = (report, status) => {
    setuserid(report.id);
    setselectedreport(report);
    console.log(selectedreport.id);
    setSelectedStatus(status);
    setAdminRemark("");
    setModalOpen(true);
  };

  // Open the modal
  const openModal = (id) => {
    setModalConfig({ isOpen: true, accId: id });
  };

  // Close the modal
  const closeModal = () => {
    setModalConfig({ isOpen: false, accId: null });
  };

  // Execute the API call
  const confirmAction = async () => {
    const { accId } = modalConfig;
    try {
      const response = await axios.delete(
        `https://payyug.in/api/fdmis/delete/${accId}`,
      );
      toast.success(response?.data?.message || `Account Deleted successfully!`);
      fetchAccounts();
    } catch (err) {
      toast.error(err?.response?.data?.message || `Failed to delete account`);
    } finally {
      closeModal();
    }
  };

  // pagination(frontend)
  const totalPages = Math.max(
    1,
    Math.ceil(filteredAccounts.length / itemsPerPage),
  );

  const paginatedAccounts = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return filteredAccounts.slice(start, end);
  }, [filteredAccounts, currentPage, itemsPerPage]);

  // Reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeSecondary, searchQuery, frequency, itemsPerPage]);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="fdmis-account-report-container">
      {/* Filter Section */}
      <section className="fdmis-report-filters-section">
        <h2 style={{ textAlign: "center", marginBottom: 10 }}>
          {activeMainTab} Account Report
        </h2>

        {/* Main Tabs */}
        <div className="fdmis-report-filters-main-tabs">
          {["FD", "MIS"].map((tab) => (
            <button
              key={tab}
              className={`fdmis-report-filters-main-tab ${
                activeMainTab === tab ? "active" : ""
              }`}
              onClick={() => setActiveMainTab(tab)}
            >
              {tab} Report
            </button>
          ))}
        </div>

        {/* Secondary Tabs */}
        <div className="fdmis-report-filters-secondary-tabs">
          {secondaryTabs.map((tab) => (
            <button
              key={tab}
              className={`fdmis-report-filters-secondary-btn ${
                activeSecondary === tab ? "active" : ""
              }`}
              onClick={() => setActiveSecondary(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* <div className="dropdown-filter ">
           <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
          <option value="All">All</option>
          <option value="Daily">Daily</option>
          <option value="Weekly">Weekly</option>
          <option value="Monthly">Monthly</option>
        </select>
      </div> */}
      </section>

      <div className="fdmis-report-search-section">
        <div>
          <label>Show </label>
          <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
            {ITEMS_PER_PAGE_OPTIONS.map((count) => (
              <option key={count} value={count}>
                {count}
              </option>
            ))}
          </select>
          <span> entries</span>
        </div>
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="fdmis-report-table-wrapper">
        <table className="fdmis-report-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>Roi</th>
              {activeMainTab==="MIS" &&<th>Interest Amount</th>}
              <th>Deposit Amount</th>
              <th>Opening Date</th>
              <th>Tenure</th>
              <th>Status</th>
              {activeMainTab==="MIS" && <th>Pay</th>}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : paginatedAccounts.length === 0 ? (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            ) : (
              paginatedAccounts.map((acc, index) => (
                <tr key={acc.id}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{acc.accountNumber || "N/A"}</td>
                  <td>{acc?.customer?.fullName || "N/A"}</td>
                  <td>{acc.accountType || "N/A"}</td>
                  <td>{`${acc.roi}%` || "N/A"}</td>
                  {activeMainTab==="MIS" &&<td>₹{acc.monthlyInterest || 0}</td>}
                  <td>₹{acc.depositAmount || acc.minDeposit || 0}</td>
                  <td>{acc.openingDate?new Date(acc.openingDate).toLocaleDateString("en-GB"):"N/A"}</td>
                  <td>{acc.tenureMonths || "N/A"}</td>
                  <td>{acc.status || "N/A"}</td>
                  {activeMainTab==="MIS" && <td>
                    <button onClick={()=>navigate(`/Banking/MisPay/${acc.id}`,{ state: { acc } })} className="loan-pre-closer-btn loan-pre-closer-btn-approve">
                      <ArrowUpRight size={18}/>
                    </button>
                    </td>}

                  <td className="loan-pre-closer-actions">
                    {acc.status.toLowerCase() === "pending" && (
                      <>
                        <button
                          title="Approve"
                          className="loan-pre-closer-btn loan-pre-closer-btn-approve"
                          onClick={() => openRemarkModal(acc, "approve")}
                        >
                          <CheckCircle size={18} />
                        </button>

                        <button
                          title="Reject"
                          className="loan-pre-closer-btn loan-pre-closer-btn-reject"
                          onClick={() => openRemarkModal(acc, "reject")}
                        >
                          <XCircle size={18} />
                        </button>
                      </>
                    )}

                    <button
                      title="Delete"
                      className="loan-pre-closer-btn loan-pre-closer-btn-delete"
                      onClick={() => openModal(acc.id)}
                    >
                      <Trash size={18} />
                    </button>
                  </td>
                  {/* <td>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <button
                        className="approve-btn"
                        onClick={() => openRemarkModal(acc, "approve")}
                        disabled={acc.status?.toLowerCase() !== "pending"}
                      >
                         {acc.status?.toLowerCase()==="active"?"Approved":"Approve"}
                      </button>

                      <button
                        className="reject-btn"
                        onClick={() => openRemarkModal(acc, "reject")}
                        disabled={acc.status?.toLowerCase() !== "pending"}
                      >
                        {acc.status?.toLowerCase()==="rejected"?"Rejected":"Reject"}
                      </button>
                    </div>
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="fdmis-report-pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      )}

      {/* Modal */}
      {modalOpen && (
        <div className="remark-modal-overlay">
          <div className="remark-modal">
            <h3>
              {selectedStatus === "approve"
                ? "Approve report"
                : "Reject report"}
            </h3>

            <textarea
              placeholder="Enter admin remark"
              value={adminRemark}
              onChange={(e) => setAdminRemark(e.target.value)}
            ></textarea>

            <div className="modal-buttons">
              <button className="modal-submit" onClick={submitStatusUpdate}>
                Submit
              </button>
              <button
                className="modal-cancel"
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* delete modal  */}
      {modalConfig.isOpen && (
        <div className="loan-pre-closer-modal-overlay">
          <div className="loan-pre-closer-modal-content">
            <div
              className={`loan-pre-closer-modal-icon icon-delete`}
            >
              <Trash size={40} />
            </div>
            <h2>
              Confirm{" "}
              {"delete".charAt(0).toUpperCase() +
                "delete".slice(1)}
            </h2>
            <p>
              Are you sure you want to <b>delete</b> this account
              record? This action might be irreversible.
            </p>

            <div className="loan-pre-closer-modal-actions">
              <button
                className="loan-pre-closer-btn-cancel"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className={`loan-pre-closer-btn-confirm btn-${modalConfig.type}`}
                onClick={confirmAction}
              >
                Confirm {modalConfig.type}
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default FdMisReport;
